module.exports = __webpack_public_path__ + "static/media/roller-skate.146cd874.png";